<div class="tw-flex tw-flex-col tw-gap-[16px]">
  <div class="tw-flex tw-gap-[8px] tw-justify-between iss-content-panel-header" *ngIf="!hideHeader">
    <div class="tw-flex tw-gap-[8px] tw-items-center">
      <iss-icon *ngIf="icon" [name]="icon"/>
      <span *ngIf="title">{{ title }}</span>
      <ng-content select="[issContentPanelTitle]" />
    </div>
    <ng-content select="[issContentPanelActions]"/>
  </div>
  <div class="iss-content-panel-section"><ng-content/></div>
  <div class="tw-flex tw-items-center tw-gap-[8px] tw-justify-end iss-content-panel-section"><ng-content select="button,[issContentPanelButton]"/></div>
</div>
